import React from "react";
import { FormattedMessage } from "react-intl";
import Moment from "react-moment";
import { Typography } from "@material-ui/core";

const ContractPhaseDateLabel = ({ contract }) => {
  const phaseInfo = phaseMap[contract.phase];

  if (!phaseInfo) return null;

  return (
    <Typography
      variant="body2"
      color="textPrimary"
    >
      <FormattedMessage id={phaseInfo.messageId} />
      <Moment
        date={contract[phaseInfo.dateField]}
        format="DD/MM/YY"
      />
    </Typography>
  );
};

const phaseMap = {
  EXECUTING: {
    messageId: "app.contract.phase.executing",
    dateField: "initialDate",
  },
  REDEEMED: {
    messageId: "app.contract.phase.redeemed",
    dateField: "updatedAt",
  },
  WAITING_SIGN: {
    messageId: "app.contract.phase.created",
    dateField: "createdAt",
  },
  WAITING_APORT: {
    messageId: "app.contract.phase.created",
    dateField: "createdAt",
  },
  WAITING_VALIDATION: {
    messageId: "app.contract.phase.created",
    dateField: "createdAt",
  },
  VALIDATING: {
    messageId: "app.contract.phase.created",
    dateField: "createdAt",
  },
  CANCELED: {
    messageId: "app.contract.phase.canceled",
    dateField: "updatedAt",
  },
};

export default ContractPhaseDateLabel;
